<template>
  <div id="app">

    <!-- 페이지 -->
    <router-view/>

  </div>
</template>
<script>
export default {
  data: () => ({}),
  methods: {},
  mounted(){},
}
</script>
